import { useCallback, useRef, useState } from 'react';

import Webcam from 'react-webcam';
import PrimaryButtonV2 from '../UI/Buttons/PrimaryButtonV2';
import switchIcon from '../../assets/icons/switch-camera.svg';
import classes from './Webcam.module.css';
import { useTranslation } from '../../hooks/useTranslations';
const FACING_MODE_USER = 'user';
const FACING_MODE_ENVIRONMENT = 'environment';

type Props = {
  imageData: string;
  onCaptureImage: (newImageData: string) => void;
  onSaveImage: () => void;
};

const WebcamCapture: React.FC<Props> = ({ imageData, onCaptureImage, onSaveImage }) => {
  const webcamRef = useRef<any>();
  const [facingMode, setFacingMode] = useState(FACING_MODE_USER);
  const { translations } = useTranslation();

  const videoConstraints = {
    width: 500,
    height: 378,
    facingMode: facingMode,
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    onCaptureImage(imageSrc);
  }, [onCaptureImage]);

  const handleClick = useCallback(() => {
    setFacingMode((prevState) =>
      prevState === FACING_MODE_USER ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER
    );
  }, []);

  return (
    <div>
      <div style={{ textAlign: 'center' }}>
        {imageData === '' ? (
          <div className={classes.previewContainer}>
            <Webcam
              audio={false}
              height={378}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              width={500}
              videoConstraints={videoConstraints}
            />
            <div className={classes.switchButtonContainer} onClick={handleClick}>
              <img src={switchIcon} alt={'switch-camera'} />
            </div>
          </div>
        ) : (
          <img src={imageData} alt="capturedImg" />
        )}
      </div>
      <div style={{ textAlign: 'center' }}>
        {imageData !== '' ? (
          <div style={{ width: '100%' }}>
            <PrimaryButtonV2
              text={translations('save')}
              buttonStyle={{
                width: '100%',
                height: 60,
                marginTop: 20,
              }}
              onClick={onSaveImage}
              disabled={false}
            />
            <PrimaryButtonV2
              text={translations('retake.image')}
              containerStyle={{
                marginTop: '20px',
                width: '100%',
              }}
              invertedColors
              buttonStyle={{
                width: '100%',
                border: 'none',
                backgroundColor: 'inherit',
                boxShadow: 'none',
              }}
              onClick={(e) => {
                e.preventDefault();
                onCaptureImage('');
              }}
              disabled={false}
            />
          </div>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 20 }}>
            <PrimaryButtonV2
              text={translations('take.picture')}
              buttonStyle={{
                width: '100%',
                height: '60px',
              }}
              containerStyle={{ width: '100%' }}
              onClick={(e) => {
                e.preventDefault();
                capture();
              }}
              disabled={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default WebcamCapture;
